var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusGray20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1289 4.16927C11.1289 3.70903 10.7558 3.33594 10.2956 3.33594C9.83534 3.33594 9.46224 3.70903 9.46224 4.16927V9.16927H4.46224C4.002 9.16927 3.62891 9.54237 3.62891 10.0026C3.62891 10.4628 4.002 10.8359 4.46224 10.8359H9.46224V15.8359C9.46224 16.2962 9.83534 16.6693 10.2956 16.6693C10.7558 16.6693 11.1289 16.2962 11.1289 15.8359V10.8359H16.1289C16.5891 10.8359 16.9622 10.4628 16.9622 10.0026C16.9622 9.54237 16.5891 9.16927 16.1289 9.16927H11.1289V4.16927Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusGray20);
export default __webpack_public_path__ + "static/media/plus-gray-20.5c2d8b7232a16bd4ab4cc0184c92e665.svg";
export { ForwardRef as ReactComponent };